import {
  SHOPIFY_BILLING_CANCEL,
  SHOPIFY_BILLING_PLANS,
  SHOPIFY_BILLING_SUBSCRIBE,
  SHOPIFY_BILLING_UPDATE_CAPPED_AMOUNT,
  SHOPIFY_SHOP,
  SHOPIFY_SHOPS,
} from '@mm/api-routes';
import { ShopifyPlan } from '../model/ShopifyModel';
import AuthenticatedController from './AuthenticatedController';
import { ShopifyData, ShopifyShop } from '../interfaces/shopify';
import { Pagination } from '../store-interfaces';

export default class ShopifyController extends AuthenticatedController {
  static async getShops(): Promise<{
    shops: ShopifyData;
    pagination: Pagination;
  }> {
    return super.get(SHOPIFY_SHOPS);
  }

  static async getShop(id: number | string): Promise<ShopifyShop> {
    return super.get(SHOPIFY_SHOP(id));
  }

  static async getShopifyPlans(): Promise<{ plans: ShopifyPlan[] }> {
    return super.get(SHOPIFY_BILLING_PLANS);
  }

  static async subscribeShopifyPlan(
    shopId: number,
    planId: number,
  ): Promise<{ confirmationUrl: string }> {
    return super.post(SHOPIFY_BILLING_SUBSCRIBE, {
      shopId,
      planId,
    });
  }

  static async cancelShopifyPlan(
    shopId: number,
  ): Promise<{ success: boolean }> {
    return super.get(SHOPIFY_BILLING_CANCEL, {
      shop_id: shopId,
    });
  }

  static async updateCappedAmount(
    shopId: number,
    cappedAmount: number,
  ): Promise<{ updateCappedAmountUrl: string }> {
    return super.get(SHOPIFY_BILLING_UPDATE_CAPPED_AMOUNT, {
      shop_id: shopId,
      capped_amount: cappedAmount,
    });
  }
}
